import { topic } from './studyToolTopicRule';
/** Mapping is not admission: candidates/preview routes remain excluded by the recommendation gate. */
export const EARTH_TOPICS = [
  topic(
    'earth-energy-budget',
    'earth energy budget|planetary albedo|absorbed solar energy',
    '地球能量收支|行星反照率|吸收太阳能',
    'Compare reflected and absorbed energy in the stated Earth model.',
    'Change planetary albedo and compare absorbed solar energy.',
    '改变行星反照率，比较地球能量收支。',
  ),
  topic(
    'solar-system-seasons',
    'earth tilt|seasonal daylight|axial tilt|seasons',
    '地轴倾角|季节日照|四季',
    'Move Earth through its orbit and compare tilt, latitude and daylight.',
    'Explain seasonal daylight using Earth tilt rather than distance from the Sun.',
    '用地轴倾角解释四季日照，而不是日地距离。',
  ),
  topic(
    'earth-moon-sun-cycles',
    'moon phase|lunar phase|solar eclipse|lunar eclipse',
    '月相|日食|月食',
    'Move the Moon and compare phase with the alignment needed for an eclipse.',
    'A new moon does not always cause a solar eclipse.',
    '新月不一定发生日食，要检查三者的位置。',
  ),
  topic(
    'plate-tectonics-hazards',
    'plate boundary|plate tectonics|subduction|continental drift',
    '板块边界|板块构造|俯冲|大陆漂移',
    'Compare boundary motion with landforms and hazard patterns.',
    'Compare landforms at a convergent plate boundary and a divergent boundary.',
    '比较汇聚与张裂板块边界的地形。',
  ),
  topic(
    'rock-cycle-minerals',
    'rock cycle|mineral hardness|mineral streak|igneous|metamorphic',
    '岩石循环|矿物硬度|条痕|火成岩|变质岩',
    'Trace rock changes and compare evidence for identifying minerals.',
    'Use mineral hardness and streak before placing a rock in the rock cycle.',
    '先观察矿物硬度与条痕，再分析岩石循环。',
  ),
  topic(
    'carbon-cycle-systems',
    'carbon reservoir|carbon flux|carbon cycle',
    '碳储库|碳通量|碳循环',
    'Distinguish stored carbon from flows between Earth systems.',
    'Separate a carbon reservoir from a carbon flux in the cycle.',
    '在碳循环中区分碳储库与碳通量。',
  ),
  topic(
    'weather-systems-evidence',
    'weather pressure|weather forecast|humidity|weather system',
    '天气气压|天气预报|湿度|天气系统',
    'Combine weather observations while keeping forecast uncertainty visible.',
    'Combine humidity and weather pressure before discussing a forecast.',
    '结合湿度与天气气压证据讨论预报。',
  ),
  topic(
    'water-catchments-groundwater',
    'rainfall partition|groundwater recharge|catchment runoff',
    '降雨分配|地下水补给|流域径流',
    'Compare how rainfall divides into runoff, infiltration and recharge.',
    'Compare catchment runoff with groundwater recharge after rainfall.',
    '比较降雨后的流域径流与地下水补给。',
  ),
  topic(
    'geological-time-fossils',
    'fossil evidence|superposition|strata ages|geological time',
    '化石证据|地层叠覆|地层年龄|地质年代',
    'Order layers using ages and fossils and check for conflicting evidence.',
    'Use fossil evidence and superposition to order the strata.',
    '根据化石证据与地层叠覆判断先后顺序。',
  ),
  topic(
    'natural-hazards-risk',
    'hazard exposure|vulnerability|disaster preparedness|hazard risk',
    '灾害暴露|脆弱性|防灾准备|灾害风险',
    'Compare hazard, exposure and preparedness without predicting an event.',
    'Compare hazard exposure and vulnerability for two communities.',
    '比较两个社区的灾害暴露与脆弱性。',
  ),
  topic(
    'ocean-circulation-climate',
    'seawater density|ocean circulation|thermohaline|ocean salinity',
    '海水密度|海洋环流|温盐环流|海水盐度',
    'Change seawater temperature and salinity and compare sinking tendency.',
    'Compare seawater density when ocean salinity rises.',
    '海水盐度升高时，比较海水密度。',
  ),
  topic(
    'universe-redshift-scale',
    'redshift|expanding universe|cosmological scale',
    '红移|宇宙膨胀|宇宙尺度',
    'Compare rest and observed spectral lines before interpreting redshift.',
    'Compare an observed spectral line with its rest value to find redshift.',
    '比较谱线观测值与静止值，计算红移。',
  ),
  topic(
    'topographic-maps-slope',
    'contour elevation|topographic slope|topographic map|relief height',
    '等高线高程|地形坡度|地形图|相对高度',
    'Use map elevations and distance to compare relief and slope.',
    'Use contour elevation and horizontal distance to estimate topographic slope.',
    '利用等高线高程与水平距离计算地形坡度。',
  ),
  topic(
    'geological-cross-sections',
    'geological cross-section|strata dip|layer projection',
    '地质剖面|地层倾角|地层投影',
    'Project a layer at a stated dip and identify what evidence is missing.',
    'Project strata dip into a geological cross-section.',
    '利用地层倾角绘制地质剖面。',
  ),
  topic(
    'earth-observation-vegetation',
    'ndvi calculation|satellite pixel|cloud contamination',
    'ndvi计算|卫星像元|云污染',
    'Calculate a vegetation signal and check whether a pixel is reliable.',
    'Check cloud contamination before using a satellite pixel for NDVI calculation.',
    '计算NDVI前，先检查卫星像元的云污染。',
  ),
  topic(
    'field-transect-evidence',
    'vegetation cover transect|field transect|pattern and cause',
    '植被覆盖样带|野外样带|模式与因果',
    'Compare field samples without treating a pattern as proof of its cause.',
    'Compare vegetation cover transect samples before explaining a cause.',
    '先比较植被覆盖样带数据，再讨论可能原因。',
  ),
  topic(
    'mineral-resources-recovery',
    'ore grade|process recovery|mineral recovery',
    '矿石品位|工艺回收率|矿产回收',
    'Separate ore mass, contained material and recovered material.',
    'Use ore grade and process recovery to estimate the recovered mass.',
    '根据矿石品位与工艺回收率估计回收质量。',
  ),
  topic(
    'atmosphere-lapse-stability',
    'lapse rate|atmospheric stability|dry adiabat',
    '直减率|大气稳定性|干绝热',
    'Compare a vertical temperature profile with a stated stability model.',
    'Compare the lapse rate with a dry adiabat to discuss atmospheric stability.',
    '比较直减率与干绝热条件，讨论大气稳定性。',
  ),
  topic(
    'biodiversity-quadrat-sampling',
    'simpson diversity|species richness|species abundance',
    '辛普森多样性|物种丰富度|物种丰度',
    'Compare richness and abundance rather than counting species alone.',
    'Compare species richness with Simpson diversity for the samples.',
    '比较样本的物种丰富度与辛普森多样性。',
  ),
  topic(
    'resource-stock-sustainability',
    'resource regeneration|renewable stock|resource extraction rate',
    '资源再生|可再生存量|资源开采速率',
    'Compare extraction with regeneration before projecting a resource stock.',
    'Compare resource regeneration with the resource extraction rate.',
    '比较资源再生与资源开采速率。',
  ),
  topic(
    'environmental-time-series-uncertainty',
    'observation uncertainty|environmental uncertainty|uncertainty overlap',
    '观测不确定性|环境不确定性|不确定区间重叠',
    'Compare observations and uncertainty before claiming environmental change.',
    'Check uncertainty overlap before claiming the observations differ.',
    '先检查不确定区间重叠，再判断观测是否不同。',
  ),
  topic(
    'seismic-wave-distance',
    'p-s arrival|p and s waves|seismic station distance',
    'p-s到时|p波和s波|震台距离',
    'Use arrival times to estimate station distance without inventing direction.',
    'Use P and S waves to estimate seismic station distance.',
    '根据P波和S波的到时估计震台距离。',
  ),
  topic(
    'radiometric-dating-half-life',
    'radiometric dating|parent isotope|isotope age',
    '放射性定年|母体同位素|同位素年龄',
    'Convert a remaining parent fraction into a conditional age.',
    'Use the remaining parent isotope for radiometric dating.',
    '根据剩余母体同位素进行放射性定年。',
  ),
  topic(
    'storm-hydrograph-response',
    'storm hydrograph|runoff depth|peak lag',
    '暴雨过程线|径流深度|洪峰滞时',
    'Compare storm runoff volume with the stated hydrograph scenario.',
    'Calculate runoff depth before comparing the storm hydrograph.',
    '先计算径流深度，再比较暴雨过程线。',
  ),
  topic(
    'soil-infiltration-erosion',
    'soil infiltration|erosion pressure|ground cover erosion',
    '土壤入渗|侵蚀压力|地表覆盖侵蚀',
    'Compare rainfall and infiltration before changing cover or slope.',
    'Compare soil infiltration with rainfall and discuss erosion pressure.',
    '比较降雨与土壤入渗，并讨论侵蚀压力。',
  ),
  topic(
    'groundwater-flow-gradient',
    'hydraulic gradient|darcy flux|groundwater flow',
    '水力梯度|达西通量|地下水流动',
    'Compare monitoring heads and calculate a groundwater-flow gradient.',
    'Use two monitoring heads to calculate the hydraulic gradient.',
    '根据两个监测水头计算水力梯度。',
  ),
  topic(
    'earthquake-epicentre-triangulation',
    'epicentre triangulation|earthquake triangulation|three seismic stations',
    '震中三角定位|地震三角定位|三个地震台',
    'Fit a candidate source to distance evidence from three stations.',
    'Use three seismic stations for epicentre triangulation.',
    '根据三个地震台的数据进行震中三角定位。',
  ),
  topic(
    'unconformity-missing-time',
    'unconformity|missing geological time|gap in rock record',
    '不整合|缺失地质时间|岩层记录间断',
    'Use dated units and uncertainty to constrain missing time.',
    'Compare dated units around an unconformity to estimate missing geological time.',
    '利用不整合两侧的年龄约束缺失地质时间。',
  ),
  topic(
    'catchment-water-balance',
    'catchment water balance|evapotranspiration|storage residual',
    '流域水量平衡|蒸散|储量残差',
    'Balance water inputs and outputs and inspect the storage residual.',
    'Include evapotranspiration when calculating catchment water balance.',
    '计算流域水量平衡时，纳入蒸散。',
  ),
  topic(
    'climate-anomaly-baseline',
    'climate anomaly|climate baseline|temperature anomaly',
    '气候距平|气候基准|温度距平',
    'Compare a value with a defined baseline without inventing a trend.',
    'Calculate a temperature anomaly against the stated climate baseline.',
    '根据给定气候基准计算温度距平。',
  ),
  topic(
    'satellite-vegetation-change',
    'vegetation change|before and after ndvi|ndvi difference',
    '植被变化|前后ndvi|ndvi差值',
    'Compare vegetation observations while keeping cloud and quality flags visible.',
    'Compare before and after NDVI to investigate vegetation change.',
    '比较前后NDVI，分析植被变化。',
  ),
  topic(
    'earthquake-catalogue-patterns',
    'earthquake catalogue|earthquake catalog|earthquake depth pattern',
    '地震目录|震源深度模式',
    'Inspect catalogue patterns without predicting the next earthquake.',
    'Compare depths and magnitudes in the earthquake catalogue.',
    '比较地震目录中的深度与震级。',
  ),
  topic(
    'rainfall-station-timeseries',
    'rainfall station|rainfall time series|station rainfall',
    '降雨站|降雨时间序列|测站降雨',
    'Compare one rainfall series with its own imported-series mean.',
    'Compare the latest value in a rainfall time series with its mean.',
    '比较降雨时间序列最新值与该序列平均值。',
  ),
  topic(
    'streamflow-station-hydrograph',
    'streamflow station|discharge time series|provisional discharge',
    '径流测站|流量时间序列|临时流量',
    'Read a discharge series while preserving its observation-quality states.',
    'Keep quality flags when comparing a discharge time series.',
    '比较流量时间序列时，保留数据质量标记。',
  ),
  topic(
    'fractional-cover-timeseries',
    'fractional cover|green brown bare cover|vegetation cover series',
    '组分覆盖|绿褐裸覆盖|植被覆盖序列',
    'Compare green, brown and bare cover with observation-quality checks.',
    'Compare green and bare ground in a fractional cover time series.',
    '比较组分覆盖序列中的绿色植被与裸地。',
  ),
  topic(
    'surface-geology-data-evidence',
    'surface geology|mapped lithology|geological unit attributes',
    '地表地质|制图岩性|地质单元属性',
    'Compare mapped rock units while keeping age and map-scale limits visible.',
    'Compare geological unit attributes before interpreting mapped lithology.',
    '解释制图岩性前，先比较地质单元属性。',
  ),
];
